import {
  IAction,
  internalHrefType,
  externalHrefType,
  ActionCall,
  ActionEmail,
  ActionDownload,
  ActionScroll,
} from 'bit/shared/declarations/index';

// Handler map for action types
const actionHandlers: Record<string, (action: any) => string> = {
  DatoCmsEmail: (action: ActionEmail) => `mailto:${action.useCustom ? action?.custom : action?.value?.value}`,
  EmailRecord: (action: ActionEmail) => `mailto:${action.useCustom ? action?.custom : action?.value?.value}`,
  DatoCmsCall: (action: ActionCall) => `tel:${action.useCustom ? action?.custom : action?.value?.value}`,
  CallRecord: (action: ActionCall) => `tel:${action.useCustom ? action?.custom : action?.value?.value}`,
  DatoCmsDownload: (action: ActionDownload) => action?.asset?.url ?? '#',
  DownloadRecord: (action: ActionDownload) => action?.asset?.url ?? '#',
  DatoCmsScroll: (action: ActionScroll) => `#${action?.sectionId}`,
  ScrollRecord: (action: ActionScroll) => `#${action?.sectionId}`,
  DatoCmsPopup: () => '#popup',
  PopupRecord: () => '#popup',
  DatoCmsIntercomBot: () => '#intercomBot',
  IntercomBotRecord: () => '#intercomBot',
};

function getHrefValueFromAction(actionArr: IAction): string | false {
  const action = actionArr[0];
  const handler = actionHandlers[action.__typename as string];
  if (handler) {
    return handler(action);
  }
  console.log(`[Warning: No dispatcher found for action block of given __typename]`);
  return false;
}

function checkLinkTarget(link?: string | false | null): string | boolean {
  const match1 = link && link.match(/http(s{0,1})/gi);
  const match2 = link && link.match(/tel:|mailto:/gi);
  const isExternal = (match1 && match1[0]) || (match2 && match2[0]) || false;
  return isExternal;
}

function postOrPageHref(href: internalHrefType | externalHrefType): string | null | undefined {
  if (typeof href === 'string') {
    return href;
  } else if (href?.__typename === 'DatoCmsPost' || href?.__typename === 'PostRecord') {
    return `/blog/${href?.category1?.slug}/${href?.slug}`;
  } else if (href?.__typename === 'DatoCmsPage' || href?.__typename === 'PageRecord') {
    return href?.slug;
  }
  return undefined;
}

function getIndexOfPopup(id?: string, currentElement?: HTMLButtonElement | null): number | undefined {
  if (id && currentElement) {
    const arrayOfElements = Array.from(document.querySelectorAll(`[data-popup-id="${id}"]`));
    const index = arrayOfElements.findIndex((el) => el === currentElement);
    return index > -1 ? index : undefined;
  }
  return undefined;
}

export { getHrefValueFromAction, checkLinkTarget, postOrPageHref, getIndexOfPopup };
